<template>
  <div class="studycon english_container">
    <myHeader />
    <!-- 高校专业共建 -->
    <div class="bg1">
      <div class="bg2">
        <div class="cen1">
          <h1 class="wow fadeInUp enProductTitle" style="font-size: 80px !important;font-weight: 900;padding: 0px;line-height: normal;">
            JOINT CONSTRUCTION OF MAJORS IN UNIVERSITIES
          </h1>
          <p class="wow fadeInUp enTwoProductTitle" style="margin-top: 20px;">Enterprises actively participate in the course design process, integrating the latest industry cases.</p>
          <router-link
            :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
            class="setting_a2"
          >
            <button class="wow fadeInUp btn__hover">Contact Us</button>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 高校课程升级 -->
    <div class="course-upgrade-container">
      <div class="image-wrapper_contain">
        <h2 class="wow fadeInUp " >Upgrading Higher Education Curricula</h2>

        <img
          src="https://download.hecoos.com/enlightv/2025-16/314262105de87104f5ff41361f536b3e.png" class="wow fadeInUp"
        />
        <p class="description wow fadeInUp">

Upgrading existing higher education curricula by incorporating industry-specific work experience and practical teaching methods to create advanced programs that combine strong foundational knowledge with real-world applicability.

        </p>
      </div>
    </div>

    <!-- 人才培养目标 -->
    <mySwitch />

    <!-- 课程内容包含 -->
    <div class="course_content">
      <div class="job_test">
        <h2 class="job_title wow fadeInUp">The course content includes</h2>
      </div>
      <div
        class="course_father"
        v-for="(item, index) in courseItems"
        :key="index"
      >
        <div class="course_contain wow fadeInUp" @click="toggleContent(index)">
          <h2 :class="{ 'show-border': item.isOpen }">{{ item.title }}</h2>
          <div :class="{ active: item.isOpen }">
            <i
              class="el-icon-error"
              :style="{
                transform: item.isOpen ? 'rotate(0deg)' : 'rotate(45deg)',
              }"
            ></i>
          </div>
        </div>
        <div class="course_contain_nei" :class="{ active: item.isOpen }">
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>

    <!-- 相关就业方向 -->
    <div class="job-directions-container">
      <div class="job_test">
        <h2 class="job_title wow fadeInUp">Related employment directions</h2>
      </div>
      <div class="job-directions">
        <div class="father_wai" v-for="(item, index) in jobItems" :key="index">
          <div
            class="job_contains wow fadeInUp"
            :class="{ active: item.isOpen }"
            @click="toggleOpen(index)"
          >
            <h2>{{ item.title }}</h2>
            <span
              class="underline"

              :class="{ 'visible': item.isOpen, 'animate-underline': item.isOpen }"
              :style="{ width: item.isOpen? item.underlineWidth + 'px' : '0px' }"
            ></span>
            <div>
              <img
                :src="item.imgSrc"
                alt="图标"
                :class="{ rotate: item.isOpen }"
              />
            </div>
          </div>
          <div class="open_box" :class="{ active: item.isOpen }">
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 职业技术培训 -->
    <div class="tech-training-wrap">
      <div class="bg-image"></div>
      <div class="text-content">
        <h1 class="wow fadeInUp enProductTitle">Vocational Technical Training</h1>
        <p class="wow fadeInUp">
          Employment oriented vocational and technical training courses aim to <br/> enhance students' professional and technical abilities, and improve graduates' competitiveness in the industry.
        </p>
      </div>
    </div>
    <myFooter />
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from "@/components/en_pc/BackToTop";
import myFooter from "@/components/en_pc/myFooter.vue";
import myHeader from "@/components/en_pc/myHeader.vue";
import mySwitch from "@/components/en_pc/mySwitch.vue";
export default {
  data() {
    return {
      jobItems: [
        {
          title: "01.Design and Planning",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description:
            "Responsibilities: Artistic design of light and shadow works, interactive works, 3D Mapping design, exhibition scene design and planning",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "02.Content Production",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description:
            "Responsibilities: Production, editing, media material processing, 3D Mapping material production, interactive material production of audio and video materials",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "03.Broadcast control technology engineer",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Environment setup, technical debugging, on-site broadcasting control, equipment control",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "04.Rehearsator",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Stage effect rehearsal, stage modeling",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "05.designer",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Music design, fashion design, scene design, virtual scene design",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "06.Director",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Film and television shooting, production of storyboard scripts, directing the camera team, camera switching",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "07.Screenwriting and Planning",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Activity process management, scriptwriting, scriptwriting, and program planning",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "08.director",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Director, Executive Director, Film and Television Production, Work Coordination, Performance Guidance",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "09.XR Technical Engineer",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Director, Executive Director, Film and Television Production, Work Coordination, Performance Guidance",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "10.Digital Interaction Technology Engineer",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "Responsibilities: Interactive content creation, on-site equipment installation, debugging",
          isOpen: false,
          underlineWidth: 0,
        },
      ],
      courseItems: [
        {
          title: "Stage rehearsal series courses",
          description:
            "·Stage design, audio and video technology, editing, music theory, lighting design, environment construction, technical debugging, on-site broadcast control, equipment control, stage effect rehearsal, stage modeling",
          isOpen: false,
        },
        {
          title: "Broadcast Control Technology 3D Mapping Series Course",
          description:
            "·Scene design, visual effect design, principles of light and shadow technology, principles of interaction technology, principles of 3D Mapping technology, principles of LED display, introduction to broadcasting control technology, network technology, practical operation of broadcasting control software, equipment control technology, lighting control, synchronization technology, etc\n·Introduction to Scheme Planning, Styling, Color, Art Design, etc \n·Media material production technology, interactive technology principles, 3D space design basics, etc    ",
          isOpen: false,
        },
        {
          title: "XR Virtual Production Series Courses",
          description:
            "·Music design, fashion design, scene design, virtual scene design \n ·Literary expression, screenwriting, program planning, organizational coordination, performing arts, directing, film and television production \n ·Introduction, lens design, photography and videography, 3D modeling, editing, audio and video technology, storyboard production, team coordination, etc \n ·Virtual Engine, LED Display Principle, Introduction to Broadcast Control Technology, Network Technology, Broadcast Control Software Operation, Equipment Control Technology, xR Technology Principle, xR Debugging Process, etc  ",
          isOpen: false,
        },
        {
          title: "Interactive Art Installation Series Courses",
          description:
            "·Digital art design, interactive art design, innovative design, visual expression \n ·Basic concepts and principles of digital art, basic principles and techniques of interactive design, innovative thinking and technical implementation capabilities ",
          isOpen: false,
        },
      ],
      switchTexts: [
        "舞台预演系列课程",
        "播控技术3D Mapping系列课程",
        "xR虚拟制作系列课程",
        "交互艺术装置系列课程",
      ],
      currentIndex: 0,
      translateX: 0,
      startX: 0,
      isMoving: false,
      isContentVisible: false,

      imageUrl: 'https://download.hecoos.com/enlightv/2025-17/1505257789b71bf7dc8fa2cb50119bb3.png',

      jobDirections: [
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/cc93871edf369b73b7214cd432d85db8.png',
          title: "设计与策划",
          description:
            "光影作品艺术设计、交互作品艺术设计、3D Mapping设计、展览展会场景设计与策划",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/d6816b5e5b7dc221fb1a34a2ec92ed51.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/9eefc0d5617d430c480648331638ac81.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/479acda74243541f59d06acf7fbfd6f4.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/d6902e850d8fcc764277e462f0b203ac.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/aafde08ad843bce044166d7eb1edb08f.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/dbe10cc7690463a566ce5f974cfaec30.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        // 依次添加其他就业方向数据
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/19639819b2d45697eb76ac2c852b8e68.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        // 依次添加其他就业方向数据
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/73e84a3548f0856e667397866c9c51fb.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        // 依次添加其他就业方向数据
      ],
      imageList: [
        { src: 'https://download.hecoos.com/enlightv/2025-17/5c0374f64fde20b7528ddbead941b75d.png' },
        { src: 'https://download.hecoos.com/enlightv/2025-17/5d3666e9d8a3673413a3145f171d4cbd.png', alt: "图片2" },
        { src: 'https://download.hecoos.com/enlightv/2025-17/e98056924545ac8bd5f0f65155938981.png' },
        { src: 'https://download.hecoos.com/enlightv/2025-17/1ea7b11ce611748e4489f6c574837308.png' },
      ],

      courses: [
        {
          title: "舞台预演系列课程",
          description:
            "舞台设计、音视频技术、剪辑、乐理、灯光设计、环境搭建、技术调试、现场播控、设备控制、舞台效果预演、舞台建模",
        },
        {
          title: "播控技术3D Mapping系列课程",
          description: "相关课程介绍内容1舞台设计、音视频技术、剪辑、乐理、灯",
        },
        {
          title: "XR虚拟制作系列课程",
          description: "相关课程介绍内容2灯",
        },
        {
          title: "交互艺术装置系列课程",
          description: "相关课程介绍内容3",
        },
      ],
      selectedIndex: 0,
    };
  },
  computed: {
    selectedCourse() {
      return this.courses[this.selectedIndex];
    },
  },

  // created() {
  //   this.currentImages = this.courseImages[0];
  // },
  mounted() {
    this.calculateUnderlineWidths();
  },
  methods: {
    selectCourse(index) {
      this.selectedIndex = index;
      this.selectedIndex = index;
      // 根据选中的课程索引，更新当前要展示的图片数组
      this.currentImages = this.courseImages[index];
    },
    toggleOpen(index) {
      this.jobItems[index].isOpen = !this.jobItems[index].isOpen;

    },
    calculateUnderlineWidths() {
      this.jobItems.forEach((item, index) => {
        const span = document.createElement("span");
        span.style.visibility = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.position = "absolute"; // 添加绝对定位
        span.style.fontSize = "18px"; // 设置字体大小为 32px
        span.textContent = item.title;
        document.body.appendChild(span);
        item.underlineWidth = span.offsetWidth;
        document.body.removeChild(span);
      });
    },
    toggleContent(index) {
      this.courseItems[index].isOpen = !this.courseItems[index].isOpen;
    },

    touchStart(event) {
      this.startX = event.touches[0].clientX;
      this.isMoving = true;
    },
    touchMove(event) {
      if (this.isMoving) {
        const moveX = event.touches[0].clientX - this.startX;
        this.translateX += moveX;
        this.startX = event.touches[0].clientX;
      }
    },
    touchEnd() {
      this.isMoving = false;
      const targetIndex = Math.round(-this.translateX / 1000); // 假设图片宽度为300px
      this.currentIndex = Math.min(
        Math.max(targetIndex, 0),
        this.imageList.length - 1
      );
      // 根据当前索引计算位移
      this.translateX = -this.currentIndex * 1000;
    },
    switchImage(index) {
      this.currentIndex = index;
      // 根据点击的索引计算位移
      this.translateX = -index * 1000;
      this.selectedIndex = index;
    },
  },

  components: {
    myFooter,
    myHeader,
    mySwitch,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
.setting_a2 {
  text-decoration: none;
  color: #fff;
}
</style>
